export default __webpack_public_path__ + "static/media/marchingdead.21d1e563.png";